import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography } from '@mui/material';
import { useConfirmation } from 'components/Confirmation';
import MediaTypography from 'components/MediaTypography';

import useCancelCreateGoal from '@common/modules/Report/hooks/useCancelCreateGoal';

import {
	StyledGoalsCreateHeaderCloseIcon,
	StyledGoalsCreateHeaderGoBack,
	StyledGoalsCreateHeaderWrap,
} from './styled';

interface PropsType {
	onGoBack?: () => void;
	showCancelButton: boolean;
}

function GoalsCreateHeader({ onGoBack, showCancelButton }: PropsType) {
	const handleDelete = useCancelCreateGoal({ useConfirmationHook: useConfirmation });

	return (
		<StyledGoalsCreateHeaderWrap>
			<Box minWidth="35px">
				{onGoBack && (
					<StyledGoalsCreateHeaderGoBack onClick={onGoBack}>
						<ArrowBackIcon fontSize="small" />
						<Typography
							component="span"
							sx={{ fontWeight: 600, fontSize: '14px', lineHeight: '22px' }}
						>
							Back
						</Typography>
					</StyledGoalsCreateHeaderGoBack>
				)}
			</Box>
			<MediaTypography variant="h1" variants={{ sm: 'h2' }} sx={{ flex: 1, textAlign: 'center' }}>
				Goals
			</MediaTypography>
			{showCancelButton && (
				<StyledGoalsCreateHeaderCloseIcon onClick={handleDelete}>
					<CloseIcon color="primary" />
				</StyledGoalsCreateHeaderCloseIcon>
			)}
		</StyledGoalsCreateHeaderWrap>
	);
}

export default GoalsCreateHeader;
